<template>
    <section>
        <o-dialog
            title="Delete Dialog"
            content="Are you sure you want to delete this?"
            confirm-button="Delete"
            confirm-variant="danger"
            cancel-button="Cancel" />
    </section>
</template>
